import { request } from '@helpers/fetch';
import type { PreferencesPayload, PreferencesUpdateResponse } from '@models/preferences';
import type { Response } from '@models/response';

export const apiPreferences = {
  updatePreferences(payload: PreferencesPayload): Promise<Response<PreferencesUpdateResponse>> {
    const params = new URLSearchParams({ t: payload.token });

    return request.post<Response<PreferencesUpdateResponse>>(
      `/unsubscribe/?${params.toString()}`,
      payload.preferences,
    );
  },
};
